export default class Popup {
  constructor() {

    function popupImage() {

      var popup = document.getElementById('js-popup');
      if(!popup) return;
    
      var blackBg = document.getElementById('js-black-bg');
      var closeBtn = document.getElementById('js-close-btn');
      var showBtn = document.getElementsByClassName('js-show-popup');
      

      closePopUp(blackBg);
      closePopUp(closeBtn);

      function closePopUp(elem) {
        if(!elem) return;
        elem.addEventListener('click', function(e) {
          popup.classList.toggle('is-show');
        });
      }

      document.addEventListener('DOMContentLoaded', function(){
        function menuClick(e){
          // クリックした際に実行する処理を記述
          popup.classList.toggle('is-show');
          e.preventDefault();
          var a = this.children[0].getAttribute('href');
          var target = document.getElementById("js-btn");
          target.href = a;
          var trackeventlabel = this.children[0].getAttribute('data-trackeventlabel');
          var trackeventlabel = trackeventlabel.split('_');
          target.dataset.trackeventlabel = trackeventlabel[0] + "_send_" + trackeventlabel[1];
        }
      
        // 上記で取得したすべての要素に対してクリックイベントを適用
        for(let i = 0; i < showBtn.length; i++) {
            showBtn[i].addEventListener('click', menuClick, false);
        }
          
      }, false);

    }
    popupImage();

  }

}
